'use strict';
const angular = require('angular');

export class SideNavbarComponent {
 
  constructor(FB, $firebaseAuth, $state, $cookies, $scope, $rootScope, navService, $location) {
    'ngInject';

    this.isLoggedIn = FB.isLoggedInSync;
    this.getCurrentUser = FB.getCurrentUserSync;
    this.$firebaseAuth = $firebaseAuth();
    this.$state = $state;
    this.$cookies = $cookies;
    this.isAdmin = FB.isAdminSync;
    this.$scope = $scope;
    this.$location = $location;
    this.$rootScope = $rootScope;
 

    this.navService = navService;
   
 
//Assign active class to current nav item based on page loaded
$scope.isActive = function(viewLocation) {
    return viewLocation === $location.path();
};

$scope.navigateTo = function(item){
  $location.path(item.url);
}

}

  $onInit(){
    // Get Nav 
    this.$scope.menu = this.navService.getSideBarNav();
    /**
     * Iterate through menu items and set expanded = true if any subItems match current page url
     */
    for (let index = 0; index < this.$scope.menu.length; index++) {
      const element = this.$scope.menu[index];
      var path = this.$location.path();
      if(element.url === path && !element.subItem1){
        element.ariaCurrent = true;
      }
      if(element.url === path){
        element.expanded = true;
        this.navService.setPage(element);
        this.navService.setBreadCrumb(element);
      } else {
        element.expanded = false;
      }
      
      if(element.subItem1){
        var activeSubItem = _.filter(element.subItem1, {
          url: path
        });
        if(activeSubItem.length > 0){
          element.expanded = true;
          this.navService.setPage(element);
          this.navService.setBreadCrumb(element, activeSubItem[0]);
          this.subNavActive(activeSubItem[0]);
        }
      } else {
        element.expanded = false;
      }
      
    }
   

  }
 /**
  * Set variable for page title, navigate to page url
  * @param {*} page 
  */
  gotoPage(page, subPage){
    if(subPage){
      this.$location.url(subPage.url);
      this.$rootScope.subItem = subPage;
      this.subNavActive(subPage);
      this.navService.setBreadCrumb(page, subPage);
    } else {
        this.$rootScope.page = page;
        this.$rootScope.subItem = null;
        this.$location.url(page.url);
        this.navService.setBreadCrumb(page);
    }
  }

  /**
   * Set page name and sub menu details
   * @param {*} subItem 
   * @param {*} item 
   */
  updateBreadcrumb(subItem, item){
    this.$rootScope.page = item;
    this.$rootScope.subItem = subItem;
    this.$location.url(subItem.url);
    this.showSubNav(item);
    this.subNavActive(item, subItem);
  }

  /**
   * Expand dropdown menu on page load if there are submenu items
   * @param {*} page 
   */
  // showSubNav(page){
  //   this.$scope.menu.forEach(item => {
  //     if(item.title === page.title){
  //       item.expanded = true;
  //       console.log('set item to true');
  //       console.log(item);
  //     } else {
  //       item.expanded = false;
  //     }
  //   });
  // }

  /**
   * Set current sub menu link to active
   * @param {*} page 
   * @param {*} subItem 
   */
  subNavActive(subPage){
    this.$scope.menu.forEach(element => {
      if(element.subItem1){
        for (let index = 0; index < element.subItem1.length; index++) {
          const checkUrl = element.subItem1[index].url;
          if(checkUrl.url !== subPage.url ){
            element.subItem1[index].active = false;
          }
          
        }
      }
    });
    subPage.active = true;
  }
}

export default angular.module('appApp.sidebarnav', [])
  .directive('sidebarnav', function($rootScope) {
    return {
      template: require('./sidebarnav.html'),
      controller: SideNavbarComponent,
      controllerAs:'sidebarnavCtrl',
      restrict: 'EA',
      link: function(scope, element, attrs) {
        scope.$watch('page', function(){
          scope.page = $rootScope.page;
        });
        scope.$watch('subItem', function(){
          scope.subItem = $rootScope.subItem;
        })
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/sidebarnav/sidebarnav.directive.js